import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import React, { ReactNode } from 'react';
import { slideVerticalReverse } from '../../styles/animation';
import { Box } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { ZIndex } from '@osmosis/tailwind-ui/helpers/zIndex';
import dynamic from 'next/dynamic';

const SnackbarMessage = dynamic(async () => {
  const { SnackbarMessage } =
    await import('@osmosis/nextjs-components/Snackbar');

  return SnackbarMessage;
});

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { useQuizContext } from '../../context/QuizContext';
import { ModalHookProps } from '../../hooks/useModal';

type Props = {
  message: ReactNode;
  snackbar: ModalHookProps;
};

/**
 * Snackbar shortcut for quizzes.
 */
const ShortcutSnackbar = (props: Props) => {
  const { snackbar, message } = props;
  const { changeItem } = useQuizContext();
  return (
    <AnimatePresence>
      {snackbar.isVisible && (
        <motion.div
          {...slideVerticalReverse()}
          style={{
            position: 'fixed',
            zIndex: ZIndex.MODAL,
            bottom: 0,
            left: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box pb={5}>
            <SnackbarMessage
              variant="bg-gray-800"
              message={message}
              icon={
                <IconButton
                  data-testid="snackbar-close-button"
                  color="textInvert"
                  variant="transparent"
                  icon={<Icon icon={faArrowRight} />}
                  onClick={() => changeItem(1)}
                />
              }
            />
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ShortcutSnackbar;
